// extracted by mini-css-extract-plugin
export default {"primary":"Divider-module__primary___VvKR2","secondary":"Divider-module__secondary___sQ1bN"};